import { print } from 'graphql/language/printer';

// Normalize the GraphQL operation as AppSync defined in the documentation link below
// eslint-disable-next-line max-len
// https://docs.aws.amazon.com/appsync/latest/devguide/real-time-websocket-client.html#subscription-registration-message

export const graphqlOperationNormalizationAdapter = (
  getAppSyncAuthorizationInfo
) => ({
  applyMiddleware: async (options, next) => {
    options.data = JSON.stringify({
      query:
        typeof options.query === 'string'
          ? options.query
          : print(options.query),
      variables: options.variables
    });

    options.extensions = {
      authorization: await getAppSyncAuthorizationInfo()
    };

    delete options.operationName;
    delete options.variables;

    next();
  }
});
